module.exports = __webpack_public_path__ + "img/museo-patagonia.dc890b5c.jpg";